/**
 * 对话框函数，参考easy-dialog.js
 */

export interface DialogOptions {
  container: string | DialogTemplate | null; // Container can be a direct HTMLElement or a template object.
  overlay: boolean;
  html?: string,
  drag: boolean;
  closeBtn: string;
  fixed: boolean;
  follow: HTMLElement | string | null;
  followX: number;
  followY: number;
  autoClose: number;
  customClassName: string;
  lock: boolean;
  callback: () => void;
}

const defaultOptions: DialogOptions = {
  container: null,
  overlay: true,
  drag: true,

  closeBtn: 'closeBtn',
  customClassName: '',
  fixed: true,
  follow: null,
  followX: 0,
  followY: 0,
  autoClose: 0,
  lock: false,
  callback: () => { }
};

type DialogCallback = (event: any) => void;

export interface DialogTemplate {
  header?: string;
  content: string;
  yesFn?: DialogCallback;
  noFn?: boolean | DialogCallback;
  yesText?: string;
  noText?: string;
  cusTextClass?: string;
}

const rScript = /<[\/]*script[\s\S]*?>/ig;

export class Dialog {
  // private overlay: HTMLElement;

  constructor() {
  }

  public createOverlay (): HTMLElement {
    const overlay = document.createElement('div');
    overlay.style.cssText = 'margin:0;padding:0;border:none;width:100%;height:100%;background:rgba(0, 0, 0, 0.75);opacity:0.85;filter:alpha(opacity=85);z-index:9999;position:fixed;top:0;left:0;display:none';
    overlay.id = 'overlay';
    return overlay;
  }

  public createDialogBox (opt: DialogOptions): HTMLElement {
    const dialogBox = document.createElement('div');
    dialogBox.style.cssText = 'margin:0;padding:0;border:none;z-index:10000;display:none;';
    dialogBox.id = 'easyDialogBox';
    dialogBox.className = 'easyDialogBox ' + (opt.customClassName ? ` ${opt.customClassName}` : '');
    return dialogBox;
  }

  public setPosition (elem: HTMLElement, fixed: boolean): void {
    const style = elem.style;
    style.position = fixed ? 'fixed' : 'absolute';
    style.top = '50%';
    style.left = '50%';

    // dialogBox.style.position = fixed ? 'fixed' : 'absolute';
    // this.updatePosition(dialogBox);
  }

  public setFollow (dialogBox: HTMLElement, follow: HTMLElement | string, offsetX: number, offsetY: number): void {
    const followElem = typeof follow === 'string' ? document.getElementById(follow) : follow;
    if (!followElem) return;

    const rect = followElem.getBoundingClientRect();
    dialogBox.style.position = 'absolute';
    dialogBox.style.left = `${rect.left + offsetX + window.scrollX}px`;
    dialogBox.style.top = `${rect.top + offsetY + window.scrollY}px`;
  }

  public updatePosition (dialogBox: HTMLElement): void {
    dialogBox.style.left = '50%';
    dialogBox.style.top = '50%';
    dialogBox.style.transform = 'translate(-50%, -50%)';
  }
  public createDialogWrap (tmpl: DialogTemplate): HTMLElement {
    const header = tmpl.header ? `<h4 class="easyDialog_title"><a href="javascript:void(0)" title="close" class="close_btn" id="closeBtn">&times;</a>${tmpl.header}</h4>` : '';
    const yesBtn = tmpl.yesFn ? `<button class="btn_highlight" id="easyDialogYesBtn">${tmpl.yesText || 'OK'}</button>` : '';
    const noBtn = tmpl.noFn ? `<button class="btn_normal" id="easyDialogNoBtn">${tmpl.noText || 'Cancel'}</button>` : '';
    const footer = yesBtn || noBtn ? `<div class="easyDialog_footer">${noBtn}${yesBtn}</div>` : '';
    const dialogTmpl = `
        <div class="easyDialog_content">
            ${header}
            <div class="easyDialog_text">${tmpl.content}</div>
            ${footer}
        </div>`;

    let dialogWrap = document.getElementById('easyDialogWrapper')

    if (!dialogWrap) {
      dialogWrap = document.createElement('div');
      dialogWrap.id = 'easyDialogWrapper';
      dialogWrap.className = 'easyDialog_wrapper';
    }

    dialogWrap.innerHTML = dialogTmpl.replace(rScript, '');
    return dialogWrap;
  }


}
const createHtml = (tmp: string): HTMLElement => {
  const dialogWrap = document.createElement('div');
  dialogWrap.innerHTML = tmp.replace(rScript, '');
  return dialogWrap;
}

// loadCSS('css/easy-dialog.css');

let timer: number | undefined;

const escClose = (e: KeyboardEvent) => {
  if (e.code === 'ESC') {
    close();
  }
}
const clearTimer = () => {
  if (timer) {
    clearTimeout(timer);
    timer = undefined;
  }
}

export const open = (options: Partial<DialogOptions>) => {
  const doc = document.documentElement;
  const dialog = new Dialog();
  const opt: DialogOptions = { ...defaultOptions, ...options };

  clearTimer();

  // 如果页面中已经缓存遮罩层，直接显示
  let overlay: HTMLElement | null = null;

  if (opt.overlay) {
    overlay = document.getElementById('overlay');
    if (overlay == null) {
      overlay = dialog.createOverlay();
      document.body.appendChild(overlay);
    }
    if (opt.autoClose) {
      overlay.addEventListener('click', function () {
        close();
      });
    }
    overlay.style.display = 'block';
    overlay.style.opacity = '0.85';

    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.style.display = 'block';
  }

  // 如果页面中已经缓存弹出层，直接显示
  let dialogBox = document.getElementById('easyDialogBox');
  if (!dialogBox) {
    dialogBox = dialog.createDialogBox(opt);
    document.body.appendChild(dialogBox);
  }



  if (opt.follow) {
    const follow = () => {
      dialog.setFollow(dialogBox!, opt.follow!, opt.followX, opt.followY);
    }

    follow();
    window.addEventListener('resize', follow);

    if (overlay) {
      overlay.setAttribute("aria-modal", "false");
      overlay.style.display = 'none';
    }
  } else {
    dialog.setPosition(dialogBox!, opt.fixed || false);
  }

  dialogBox!.style.display = 'block';

  // 判断弹出层内容是否已经缓存过
  const dialogWrap = opt.html ? createHtml(opt.html) : (typeof opt.container === 'string' ?
    document.getElementById(opt.container)! :
    dialog.createDialogWrap(opt.container as DialogTemplate)!);

  const boxChild = dialogBox.getElementsByTagName('*')[0] as HTMLElement;
  if (!boxChild) {
    dialogBox.appendChild(dialogWrap);
  } else if (boxChild && dialogWrap !== boxChild) {
    boxChild.style.display = 'none';
    document.body.appendChild(boxChild);
    dialogBox.appendChild(dialogWrap);

  }
  dialogWrap.style.display = 'block';


  const docWidth = doc.clientWidth;
  const docHeight = doc.clientHeight;

  const eWidth = dialogWrap?.offsetWidth ?? 0,
    eHeight = dialogWrap?.offsetHeight ?? 0,
    widthOverflow = eWidth > docWidth,
    heigthOverflow = eHeight > docHeight;


  // 强制去掉自定义弹出层内容的margin	
  // dialogWrap.style.marginTop = dialogWrap.style.marginRight = dialogWrap.style.marginBottom = dialogWrap.style.marginLeft = '0px';

  // 居中定位
  if (!opt.follow) {
    dialogBox.style.marginLeft = '-' + (widthOverflow ? docWidth / 2 : eWidth / 2) + 'px';
    dialogBox.style.marginTop = '-' + (heigthOverflow ? docHeight / 2 : eHeight / 2) + 'px';
  }
  else {
    dialogBox.style.marginLeft = dialogBox.style.marginTop = '0px';
  }

  // ------------------------------------------------------
  // --------------------绑定相关事件----------------------
  // ------------------------------------------------------
  const closeBtn = dialogWrap.querySelector("#" + opt.closeBtn)!;

  const dialogTitle = dialogWrap.querySelector('#easyDialogTitle')!;
  const dialogYesBtn = dialogWrap.querySelector('#easyDialogYesBtn')!;
  const dialogNoBtn = dialogWrap.querySelector('#easyDialogNoBtn')!;

  // 绑定确定按钮的回调函数
  if (dialogYesBtn) {
    dialogYesBtn.addEventListener('click', function (event) {
      if (opt.container) {
        if (typeof opt.container !== 'string') {
          if (typeof opt.container.yesFn === 'function') {
            // @ts-ignore: 2367
            if (opt.container.yesFn.call(dialog, event) !== false) {
              close();
            }
          }
        }
        // if (typeof opt.container.yesFn === 'function') {
        //   if (opt.container.yesFn.call(dialog, event) !== false) {
        //     close();
        //   }
        // }
      }
    });
  }

  // 绑定取消按钮的回调函数
  if (dialogNoBtn) {
    const noCallback = (event: Event) => {
      if (opt.container) {
        if (typeof opt.container !== 'string') {
          if (typeof opt.container.noFn === 'function') {
            // @ts-ignore: 2367
            if (opt.container.noFn === true || opt.container.noFn.call(dialog, event) !== false) {
              close.call(this, opt);
            }
          }
        }
      }
    };
    dialogNoBtn.addEventListener('click', noCallback);
    // 如果取消按钮有回调函数 关闭按钮也绑定同样的回调函数
    if (closeBtn) {
      closeBtn.addEventListener('click', noCallback);
    }
  }
  // 关闭按钮绑定事件	
  else if (closeBtn) {
    closeBtn.addEventListener('click', close.bind(this, opt));
  }

  // ESC键关闭弹出层
  if (!opt.lock) {
    document.addEventListener('keyup', escClose);
  }

  if (opt.autoClose && typeof opt.autoClose === 'number') {
    timer = window.setTimeout(() => close.call(this, opt), opt.autoClose);
  }
}
export const close = (options?: DialogOptions) => {
  const dialogBox = document.getElementById('easyDialogBox');
  if (dialogBox) {
    // dialogBox.parentNode?.removeChild(dialogBox);
    dialogBox.style.display = "none"
  }
  const overlay = document.getElementById('overlay');
  if (overlay) {
    overlay.setAttribute("aria-modal", "false")
    overlay.style.display = 'none';
  }

  if (options) {
    // 执行callback
    if (typeof options.callback === 'function') {
      options.callback.call(dialogBox);
    }
  }
}

export const Alert = (contentInfo: string, yesFn: DialogCallback) => {
  if (!yesFn) {
    yesFn = function () { }
  }
  open({
    container: {
      content: '<span class="Font_15">' + contentInfo.replace(new RegExp('\n', 'g'), '<br/>') + '</span>',
      yesFn: yesFn,
      yesText: '<span class="Font_15">OK</span>'
    }
  });
}

function btnFnClose (event: any) {
  close();
  return false;
};

function btnFnCancel (event: any) {
  close();
  return false;
};


export const Confirm = (contentInfo: string) => {
  open({
    container: {
      content: '<span class="Font_15">' + contentInfo.replace(new RegExp('\n', 'g'), '<br/>') + '</span>',
      yesFn: btnFnClose,
      yesText: '<span class="Font_15">OK</span>',
      noFn: btnFnCancel,
      noText: '<span class="Font_15">Cancel</span>'
    },
    drag: true
  });
}

export default {
  open,
  close
}
